// Home.js
import React, { useEffect, useContext, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../pages/languagecontext";
import API from "../pages/Services/Baseservice";
import ClipLoader from "react-spinners/ClipLoader";
import image16 from "../assets/img/Image (2).png";
import Hero from "../assets/img/Hero.png";
import Hero2 from "../assets/img/hero-2.png";
import CCIC from "../assets/img/ccic-logo.svg";
import Heroflag from "../assets/img/HERO-FLAG.png";
import Vector from "../assets/img/Vector.svg";
import Arrow from "../assets/img/about arrow.svg";
import Arrow2 from "../assets/img/about arrow-2.svg";
import City1 from "../assets/img/city1.png";
import City2 from "../assets/img/city2.png";
import Arrow1 from "../assets/img/service-images/Arrow1.png";
import FAQ from "../assets/img/FAQ.png";
import CheckEligibility from "../pages/checkeligibility.js";
import CalendarIcon from "../assets/img/blog-images/.svg";
import SEO from "./SEO";
const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  const cleanHTML = (html = "") =>
    html.replace(/(width|height)="[^"]*"/gi, "").replace(/style="[^"]*"/gi, "");

  const viewAllOurServices = () => {
    navigate("/service");
  };
  const viewAllNews = () => {
    navigate("/news");
  };

  const viewallblog = () => {
    navigate("/blog");
  };
  const [visibleCount, setVisibleCount] = useState(3);
  const [startindex, setStartIndex] = useState(0);
  const [visibleCount1, setVisibleCount1] = useState(3);
  const [startindex1, setStartIndex1] = useState(0);
  const { selectedLanguage } = useContext(LanguageContext);
  const [weblanguageratinglist, setWebLanguageRatingList] = useState("");
  const [webhighesteducation, setWebHeightEducation] = useState("");
  const [webJobExperience, setWebjobExperience] = useState("");
  const [webSecondlanguagelist, setWebSecondLanguage] = useState("");
  const [webmaritalstatus, setWebMaritalStatus] = useState("");
  const [webaptabilityfactors, setWebaptabilityfactors] = useState("");
  const [webservice, setWebService] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhoneNumber] = useState("");
  const [age, setAge] = useState("");
  const [pages, setPages] = useState([]);
  const [nameerr, setNameErr] = useState("");
  const [emailErr, setEmaiErr] = useState("");
  const [phonenumbererr, setPhonenumberErr] = useState("");
  const [ageerr, setAgeErr] = useState("");
  const [languageratingerr, setLanguageRatingErr] = useState("");
  const [educationerr, setEducationErr] = useState("");
  const [jobexperienceerr, setJonExperienceErr] = useState("");
  const [jobstatuserr, setJobStatusErr] = useState("");
  const [success, setSuccess] = useState("");
  const [success1, setSuccess1] = useState("");
  const [checkeligibilitieslist, setEligibilitieslist] = useState("");
  const [dropdownrating, setDropdownRating] = useState("");
  const [educationdropdown, setEducationDropDown] = useState("");
  const [dropdownjobexperience, setDropDownJobExperience] = useState("");
  const [dropwnsecondlanguage, setDropDownSecondLanguage] = useState("");
  const [status, setStatus] = useState("");
  const [dropdownadaptability, setDropDownAdaptaBility] = useState("");
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [Email, setEMAIL] = useState("");
  const [message, setMessage] = useState("");
  const [dropdown, setDropDown] = useState([]);
  const [firstnameerr, setFirstNameErr] = useState("");
  const [lastnameerr, setLastNameErr] = useState("");
  const [emailerr, setEmailErr] = useState("");
  const [messageerr, setMessageErr] = useState("");
  const [selectvalueerr, setSelectValueErr] = useState("");
  const [contactussuccess, setContactUsSuccess] = useState("");
  const [contactusvalues, setContactUsValue] = useState("");
  const [contactus, setContactUs] = useState("");
  const [contactsupport, setcontactsupport] = useState("");
  const [listitems, setListItems] = useState("");
  const [ourservice, setOurService] = useState("");
  const [loading, setLoading] = useState(true);
  const [faq, setFaq] = useState("");
  const [newslist, setNewsList] = useState([]);
  const [list, setList] = useState([]);
  const [aboutus, setAboutUs] = useState("");
  const [aboutusvision, setAbouUsVision] = useState("");
  const [aboutusValue, setAboutUsValue] = useState("");
  const [testiMonials, setTestiMonials] = useState("");
  const [testiMonialSection, setTestiMonialSection] = useState("");
  const [videoreviews, setVideoReviews] = useState("");
  const [videotestimonials, setVideoTestimonials] = useState("");

  useEffect(() => {
    if (selectedLanguage.id) setName("");
    setNameErr("");
    setEmaiErr("");
    setEmail("");
    setPhoneNumber("");
    setPhonenumberErr("");
    setDropdownRating("");
    setLanguageRatingErr("");
    setEducationDropDown("");
    setEducationErr("");
    setDropDownJobExperience("");
    setJonExperienceErr("");
    setDropDownSecondLanguage("");
    setAge("");
    setAgeErr("");
    setStatus("");
    setJobStatusErr("");
    setDropDownAdaptaBility("");
  }, [selectedLanguage.id]);
  const home = () => {
    navigate("/");
  };
  useEffect(() => {
    if (selectedLanguage.id) languagerating();
    webhighesteducationlist();
    webjobexperience();
    websecondlanguagelist();
    webMaritalstatus();
    webAptabilityfactors();
    webservicelist();
    checkeligibilitiesList();
  }, [selectedLanguage.id]);

  const languagerating = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("weblanguagerating_list/webCondition", req).then((res) => {
      if (res.data.success === true);
      setWebLanguageRatingList(res.data.data.data);
    });
  };

  const webhighesteducationlist = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webhighesteducation_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setWebHeightEducation(res.data.data.data);
      }
    });
  };

  const webjobexperience = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webjobexperience_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setWebjobExperience(res.data.data.data);
      }
    });
  };

  const websecondlanguagelist = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("websecondlanguage_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setWebSecondLanguage(res.data.data.data);
      }
    });
  };

  const webMaritalstatus = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webmaritalstatus_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setWebMaritalStatus(res.data.data.data);
      }
    });
  };

  const webAptabilityfactors = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webadaptabilityfactors_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setWebaptabilityfactors(res.data.data.data);
      }
    });
  };

  const webservicelist = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webServices_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setWebService(res.data.data.data);
      }
    });
  };

  const handleWenLangugage = (e) => {
    const values = Number(e.target.value);
    setDropdownRating(values);
    updatePages(0, values);
  };

  const handleheightEducation = (e) => {
    const values = Number(e.target.value);
    setEducationDropDown(values);
    updatePages(1, values);
  };

  const handlejobexperience = (e) => {
    const values = Number(e.target.value);
    setDropDownJobExperience(values);
    updatePages(2, values);
  };

  const handleSecondlanguage = (e) => {
    const values = Number(e.target.value);
    setDropDownSecondLanguage(values);
    updatePages(3, values);
  };

  const handleStatus = (e) => {
    const values = Number(e.target.value);
    setStatus(values);
    updatePages(4, values);
  };

  const handleAdaptability = (e) => {
    const values = Number(e.target.value);
    setDropDownAdaptaBility(values);
    updatePages(5, values);
  };

  const checkeligibilitiesList = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webCheckEligibilities/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setEligibilitieslist(res.data.data.data[0]);
      }
    });
  };

  const updatePages = (index, value) => {
    setPages((prev) => {
      const arr = [...prev]; // copy
      arr[index] = value;
      return arr;
    });
  };

  const handlePhoneNumberChange = (e) => {
    setPhonenumberErr("");
    const value = e.target.value;
    const value1 = value.replace(/[^0-9]/g, "");
    const value2 = value1.slice(0, 10);
    setPhoneNumber(value2);
    if (value2.length !== 10) {
      setPhonenumberErr("Phone Number Must Be 10 Digits");
      return;
    }
  };

  const handlephoneNumberChange = (e) => {
    setPhonenumberErr("");
    const value = e.target.value;
    const values = value.replace(/[^0-9]/g, "");
    const values1 = values.slice(0, 10);
    setPhoneNumber(values1);
    if (values1.length !== 10) {
      setPhonenumberErr(
        selectedLanguage.id === 1
          ? "Phone Number Must Be 10 Digits"
          : "Le numéro de téléphone doit contenir 10 chiffres",
      );
      return;
    }
  };

  const handleEmailChange = (e) => {
    setEmaiErr("");
    const value = e.target.value;
    setEmail(value);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      setEmaiErr(
        selectedLanguage.id === 1
          ? "Enter a Valid Email Address"
          : "Veuillez entrer une adresse e-mail valide",
      );
      return;
    }
  };
  const checkEligibilityAdd = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let phoneNumber = phonenumber;
    phoneNumber = phoneNumber.replace(/[^0-9]/g, "");
    phoneNumber = phoneNumber.slice(0, 10);
    setPhoneNumber(phoneNumber);

    setNameErr("");
    setEmaiErr("");
    setPhonenumberErr("");
    setLanguageRatingErr("");
    setAgeErr("");
    setEducationErr("");
    setJonExperienceErr("");
    setJobStatusErr("");

    if (!name) {
      setNameErr(
        selectedLanguage.id === 1 ? "Name Is Required" : "Le nom est requis",
      );
      return;
    } else if (!email) {
      setEmaiErr(
        selectedLanguage.id === 1
          ? "Email Is Required"
          : "L’adresse e-mail est requise",
      );
      return;
    } else if (!emailRegex.test(email)) {
      setEmaiErr(
        selectedLanguage.id === 1
          ? "Enter a Valid Email Address"
          : "Veuillez entrer une adresse e-mail valide",
      );
      return;
    } else if (!phonenumber) {
      setPhonenumberErr(
        selectedLanguage.id === 1
          ? "Phone Number Is Required"
          : "Le numéro de téléphone est requis",
      );
      return;
    } else if (phonenumber.length !== 10) {
      setPhonenumberErr(
        selectedLanguage.id === 1
          ? "Phone Number Must Be 10 Digits"
          : "Le numéro de téléphone doit contenir 10 chiffres",
      );
      return;
    } else if (!dropdownrating) {
      setLanguageRatingErr(
        selectedLanguage.id === 1
          ? "First Language Rating Is Required"
          : "La note de la première langue est requise",
      );
      return;
    } else if (!educationdropdown) {
      setEducationErr(
        selectedLanguage.id === 1
          ? "Highest Education Is Required"
          : "Le niveau d’éducation le plus élevé est requis",
      );
      return;
    } else if (!dropdownjobexperience) {
      setJonExperienceErr(
        selectedLanguage.id === 1
          ? "Job Experience Is Required"
          : "L’expérience professionnelle est requise",
      );
      return;
    } else if (!age) {
      setAgeErr(
        selectedLanguage.id === 1 ? "Age Is Required" : "L’âge est requis",
      );
      return;
    } else if (!status) {
      setJobStatusErr(
        selectedLanguage.id === 1
          ? "Status Is Required"
          : "Le statut est requis",
      );
      return;
    }

    let req = {
      language_id: selectedLanguage.id,
      name: name,
      email: email,
      phone_number: phonenumber,
      /*listofservice_id: dropdownservices,*/
      eligibilitypoints_id: `[${pages.filter((x) => x !== 0 && x !== "" && x !== undefined).join(",")}]`,
      age: Number(age),
      eligibility_status: "pending",
      createdBy: 1,
      updatedBy: 1,
    };
    API.post("webAdd_checkeligibilityform/add1", req).then((res) => {
      if (res.data.success === true) {
        setSuccess1(res.data.message);
        setSuccess(res.data.data.points);
      }
    });
  };

  useEffect(() => {
    if (selectedLanguage.id) {
      dropdownlist();
    }
  }, [selectedLanguage.id]);

  const handleEmail = (e) => {
    setEmailErr("");
    const value = e.target.value;
    setEMAIL(value);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      setEmailErr("Enter a Valid Email Address");
      return;
    }
  };

  const Submit = (e) => {
    e.preventDefault();
    setFirstNameErr("");
    setLastNameErr("");
    setEmailErr("");
    setMessageErr("");
    setSelectValueErr("");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!firstname) {
      setFirstNameErr(
        selectedLanguage.id === 1
          ? "First Name Is Required"
          : "Le prénom est requis",
      );
      return;
    } else if (!lastname) {
      setLastNameErr(
        selectedLanguage.id === 1
          ? "Last Name Is Required"
          : "Le nom de famille est requis",
      );
      return;
    } else if (!Email) {
      setEmailErr(
        selectedLanguage.id === 1
          ? "Email Is Required"
          : "L’adresse e-mail est requise",
      );
      return;
    } else if (!emailRegex.test(Email)) {
      setEmailErr("Enter a Valid Email Address");
      return;
    } else if (!contactusvalues) {
      setSelectValueErr(
        selectedLanguage.id === 1
          ? "Select Name Is Required"
          : "La sélection d’un nom est requise",
      );
      return;
    } else if (!message) {
      setMessageErr(
        selectedLanguage.id === 1
          ? "Message Is Required"
          : "Le message est requis",
      );
      return;
    }

    let req = {
      language_id: selectedLanguage.id,
      first_name: firstname,
      last_name: lastname,
      email: Email,
      contactform_id: Number(contactusvalues),
      message: message,
    };
    API.post("webAddContact_Submit/add1", req).then((res) => {
      if (res.data.success === true) {
        setContactUsSuccess(res.data.message);
        setFirstName("");
        setLastName("");
        setEMAIL("");
        setMessage("");
        setContactUsValue("");

        setTimeout(() => {
          setContactUsSuccess("");
        }, 3000);
      }
    });
  };
  const dropdownlist = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webcontactservice_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setDropDown(res.data.data.data);
      }
    });
  };
  const dropdownclick = (e) => {
    const id = e.target.value;
    setContactUsValue(id);
  };

  useEffect(() => {
    if (selectedLanguage.id) {
      contactUs();
    }
  }, [selectedLanguage.id]);

  const contactUs = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webContact_List/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setContactUs(res.data.data.formFields[0]);
        setcontactsupport(res.data.data.support);
      }
    });
  };

  useEffect(() => {
    if (selectedLanguage.id) {
      webourservice();
      Faq();
      List();
      listBlog();
      aboutuspage();
      testimonials();
    }
  }, [selectedLanguage.id]);

  const webourservice = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webourserviceFullList/webCondition", req).then((response) => {
      if (response.data.success === true) {
        setOurService(response.data.data.ourservice[0]);
        setListItems(response.data.data.listitems);
      }
    });
  };

  const listofitems = listitems.slice(0, 3);
  const arrowClickExpress = (item) => {
    if (item.listofservice_id) {
      navigate("/servicedetail", {
        state: {
          id: item.listofservice_id,
          language_id: selectedLanguage.id,
        },
      });
    }
  };

  const Faq = () => {
    setLoading(true);
    let req = {
      category_id: "",
      search: "",
      language_id: selectedLanguage.id,
    };

    API.post("/webFaqs_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setFaq(res.data.data.data);
        setLoading(false);
      }
    });
  };
  const faqs = faq.slice(0, 6);
  const faqHandleClick = (item, index) => {
    navigate("/faq", { state: { faqIndex: index } });
  };

  const viewAllFaq = () => {
    navigate("/faq", { state: { scrollToFaq: true } });
  };

  const List = () => {
    setLoading(true);
    let req = {
      search: "",
      rowsPerPage: "",
      page: "",
      language_id: selectedLanguage.id,
    };

    API.post("webnews_list/webCondition", req).then((response) => {
      if (response.data.success === true) {
        setNewsList(response.data.data.data || []);
        setLoading(false);
      }
    });
  };

  const ref = useRef();

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const tooltip = el.querySelector(".tooltip-text");
    el.onmouseenter = () => {
      const isTruncated =
        el.querySelector(".truncate").scrollWidth >
        el.querySelector(".truncate").offsetWidth;
      if (isTruncated) {
        tooltip.style.visibility = "visible";
        tooltip.style.opacity = "1";
        tooltip.style.transform = "translateY(0)";
      }
    };

    el.onmouseleave = () => {
      tooltip.style.visibility = "hidden";
      tooltip.style.opacity = "0";
      tooltip.style.transform = "translateY(5px)";
    };
  }, []);

  const listBlog = () => {
    setLoading(true);
    let req = {
      page: 1,
      rowsPerPage: 3,
      language_id: selectedLanguage.id,
    };
    API.post("webblog_list/webCondition", req).then((response) => {
      if (response.data.success === true) {
        setList(response.data.data.data || []);
        setLoading(false);
      }
    });
  };

  const newsList = newslist.slice(0, 3);

  const handleReadMore = (id) => {
    navigate("/specialnews", { state: { id } });
  };

  const readBlogpage = () => {
    navigate("/blog");
  };

  const aboutuspage = () => {
    setLoading(true);

    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webaboutus_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setAboutUs(res.data.data.about_us[0]);
        setAboutUsValue(res.data.data.aboutus_title[0]);
        setAbouUsVision(res.data.data.aboutus_title[1]);
        setLoading(false);
      }
    });
  };

  const testimonials = () => {
    setLoading(true);
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webtestimoniallistview/webCondition", req).then((res) => {
      if (res.data.success === true);
      setTestiMonialSection(res.data.data.testimonials);
      setTestiMonials(res.data.data.testimonials[0]);
      setVideoReviews(res.data.data.video_reviews);
      setVideoTestimonials(res.data.data.video_testimonials);
      setLoading(false);
    });
  };

  const renders = (rating) => {
    return (
      <div>
        {[...Array(5)].map((_, index) => (
          <span
            key={index}
            className={`fa fa-star ${index < rating ? "rating-stars" : "null"}`}
          ></span>
        ))}
      </div>
    );
  };

  const handleNext = () => {
    if (startindex + visibleCount < videotestimonials.length) {
      setStartIndex((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (startindex > 0) {
      setStartIndex((prev) => prev - 1);
    }
  };
  const handleNext1 = () => {
    if (startindex1 + visibleCount1 < videoreviews.length) {
      setStartIndex1((prev) => prev + 1);
    }
  };

  const handlePrev1 = () => {
    if (startindex1 > 0) {
      setStartIndex1((prev) => prev - 1);
    }
  };

  // useEffect(() => {
  //   if (!Array.isArray(reviewdata)) return;

  //   const measure = () => {
  //     const result = {};

  //     reviewdata.forEach((item) => {
  //       if (!item?.description) return;

  //       const div = document.createElement("div");
  //       div.className = "desc-truncate";
  //       div.style.position = "absolute";
  //       div.style.visibility = "hidden";
  //       div.style.width = "250px";

  //       div.innerHTML = item.description;
  //       document.body.appendChild(div);

  //       const truncatedHeight = div.clientHeight;

  //       div.style.webkitLineClamp = "unset";
  //       div.style.maxHeight = "none";
  //       div.style.overflow = "visible";

  //       const fullHeight = div.clientHeight;

  //       result[item.review_id] = fullHeight > truncatedHeight;

  //       document.body.removeChild(div);
  //     });

  //     if (JSON.stringify(result) !== JSON.stringify(needsMore)) {
  //       setNeedsMore(result);
  //     }
  //   };

  //   requestAnimationFrame(measure);

  // }, [reviewdata, needsMore]);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setVisibleCount(1);
        setVisibleCount1(1);
      } else {
        setVisibleCount(3);
        setVisibleCount1(3);
      }
      setStartIndex(0);
      setStartIndex1(0);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const Book = (e) => {
    console.log("Button clicked"); // Add this to check if function is called
    if (navigate) {
      navigate("/bookingform");
    } else {
      console.error("navigate function not available");
    }
  };

  const formatHeading = (text) => {
    if (!text) return "";

    const lines = text.split("\n");

    // TRIM to remove extra spaces
    const firstLineWords = lines[0].trim().split(/\s+/);

    const lastWord = firstLineWords.pop();

    const firstLine =
      firstLineWords.join(" ") + ` <span style="color:red;">${lastWord}</span>`;

    return [firstLine, ...lines.slice(1)].join("<br />");
  };

  const [visaHome, setVisaHome] = useState(null);
  const visahomepage = () => {
    setLoading(true);

    API.post("webvisahome_list/webCondition", {
      language_id: selectedLanguage.id,
    })
      .then((res) => {
        if (res?.data?.success === true) {
          const list = res?.data?.data?.data || [];

          if (list.length > 0) {
            setVisaHome(list[0]);
          } else {
            setVisaHome(null);
          }
        }
      })
      .catch((err) => {
        console.error("Visa Home fetch error", err);
        setVisaHome(null);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (selectedLanguage?.id) {
      visahomepage();
    }
  }, [selectedLanguage]);

  return (
    <div style={{ overflowX: "hidden" }}>
      <SEO
        title="Canada immigration consultant | Canadian immigration services"
        description="ASRA Migration is a trusted Canada immigration consultant offering PR, work permits, study visas, and expert guidance for a smooth migration process."
        canonical="https://asraimmigration.ca/"
      />
      {loading ? (
        <div
          className="d-flex justify-content-center mt-5 align-items-center p-5"
          style={{ height: "100vh" }}
        >
          <ClipLoader color="#FF050C" size={50} />
        </div>
      ) : (
        <>
          {visaHome && (
            <section className="hero-section">
              <div className="container px-3 hero-content">
                <div className="row align-items-center">
                  <div className="col-lg-5 mb-4 mb-lg-0 text-start text-md-center text-lg-start">
                    <h1
                      className="hero-title"
                      dangerouslySetInnerHTML={{
                        __html: formatHeading(visaHome?.heading),
                      }}
                    ></h1>

                    <h6
                      className="hero-subtitle"
                      dangerouslySetInnerHTML={{
                        __html: visaHome?.description,
                      }}
                    ></h6>

                    <button
                      type="button"
                      className="btn btn-danger d-flex align-items-center justify-content-center rounded-5"
                      style={{
                        cursor: "pointer",
                        position: "relative",
                        zIndex: 1000,
                        pointerEvents: "auto",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        navigate("/bookingform");
                      }}
                    >
                      <p className="p-0 m-0">
                        {selectedLanguage.id === 1
                          ? "Book a Consultation"
                          : "Réserver une consultation"}
                      </p>
                      <i className="bi bi-arrow-right-circle-fill ms-1 book-icon"></i>
                    </button>
                  </div>

                  <div className="col-lg-6">
                    <div className="hero-right-wrapper d-flex justify-content-center">
                      <img
                        src={Hero}
                        alt="Happy family going to Canada"
                        className="img-fluid d-none d-sm-block"
                      />
                      <img
                        src={Hero2}
                        alt="Happy family going to Canada"
                        className="img-fluid d-block d-sm-none hero-mobile-img"
                      />

                      <div className="badge-card badge-welcome">
                        <span className="icon-circle">
                          <i className="bi bi-airplane-fill"></i>
                        </span>
                        <span className="fw-semibold"> {visaHome?.card1}</span>
                      </div>

                      <div className="badge-card badge-location">
                        <div className="icon-circle">
                          <i className="bi bi-geo-alt-fill"></i>
                        </div>
                      </div>

                      <div className="badge-card-3 badge-ccic d-block">
                        <img src={CCIC} alt="CCIC Logo" />
                        <p
                          className="fw-bolder"
                          dangerouslySetInnerHTML={{
                            __html: visaHome?.card2?.replace(/\n/g, "<br />"),
                          }}
                        ></p>
                      </div>

                      <div className="badge-card badge-hotel">
                        <img src={Heroflag} alt="Hotel" />
                        <div className="ms-1">
                          <h6 className="badge-hotel-title mt-2">
                            {selectedLanguage.id === 1
                              ? "Le Pirate Hotel"
                              : "Hôtel Le Pirate"}
                          </h6>
                          <p className="badge-hotel-location">
                            {selectedLanguage.id === 1 ? "Posit" : "Posit"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <img
                src={Vector}
                alt=""
                className="decorative-dots d-none d-xxl-block"
              />
            </section>
          )}

          <section>
            <div className="bg-white container px-3 py-lg-5 my-lg-5">
              <div className="row align-items-center d-flex justify-content-between">
                <div className="col-lg-6 col-xl-7 aboutsec">
                  <p className="small text-danger fw-bold mb-2">
                    {selectedLanguage.id === 1
                      ? "ABOUT US"
                      : "À PROPOS DE NOUS"}
                  </p>
                  <h2 className="fw-bold">
                    {aboutus ? aboutus.about_heading : ""}
                  </h2>
                  <p
                    className="text-muted mt-3"
                    dangerouslySetInnerHTML={{
                      __html: aboutus ? aboutus.about_description : "",
                    }}
                  ></p>

                  <div className="accordion" id="visionValueAccordion">
                    <div className="accordion-item border-0 mb-3">
                      <h2 className="accordion-header" id="headingVision">
                        <button
                          className="accordion-button ps-0 bg-transparent shadow-none fw-semibold d-flex align-items-center gap-2"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseVision"
                          aria-expanded="true"
                          aria-controls="collapseVision"
                        >
                          <span className="arrow-symbol"></span>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: aboutusvision
                                ? aboutusvision.aboutus_title_heading
                                : "",
                            }}
                          ></span>
                        </button>
                      </h2>
                      <div
                        id="collapseVision"
                        className="accordion-collapse collapse show"
                        aria-labelledby="headingVision"
                        data-bs-parent="#visionValueAccordion"
                      >
                        <div
                          className="accordion-body ps-0 text-muted pt-3"
                          dangerouslySetInnerHTML={{
                            __html: aboutusvision
                              ? aboutusvision.aboutus_title_description
                              : "",
                          }}
                        ></div>
                      </div>
                    </div>

                    <div className="accordion-item border-0">
                      <h2 className="accordion-header" id="headingValue">
                        <button
                          className="accordion-button collapsed ps-0 bg-transparent shadow-none fw-semibold d-flex align-items-center gap-2"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseValue"
                          aria-expanded="false"
                          aria-controls="collapseValue"
                        >
                          <span className="arrow-symbol"></span>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: aboutusValue
                                ? aboutusValue.aboutus_title_heading
                                : "",
                            }}
                          ></span>
                        </button>
                      </h2>
                      <div
                        id="collapseValue"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingValue"
                        data-bs-parent="#visionValueAccordion"
                      >
                        <div
                          className="accordion-body ps-0 text-muted pt-3"
                          dangerouslySetInnerHTML={{
                            __html: aboutusValue
                              ? aboutusValue.aboutus_title_description
                              : "",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="image-stack col-6 mt-5 ms-lg-0 mb-5 mb-lg-0">
                  <img src={Arrow} className="doodle-left" alt="doodle" />
                  <img src={Arrow2} className="doodle-right" alt="doodle" />
                  <img
                    src={City1}
                    className="stack-img img-back"
                    alt="city background"
                  />
                  <img
                    src={City2}
                    className="stack-img img-front"
                    alt="city foreground"
                  />
                </div>
              </div>
            </div>
          </section>

          <div className="bg-black my-mb-5 py-mb-5">
            <section className="service-section text-center container px-3 my-5 py-5">
              <section className="service-header-section text-start mb-4">
                <div className="container-fluid px-2 row d-flex justify-content-between align-items-center">
                  <div className="col-md-8 col-fluid">
                    <h6 className="service-subtitle text-danger fw-bold">
                      {ourservice ? ourservice.heading : ""}
                    </h6>
                    <h2 className="service-title text-white fw-bold">
                      {ourservice ? ourservice.title : ""}
                    </h2>
                  </div>
                  <a className="service-view-all text-decoration-none col-md-3 text-danger col-fluid">
                    <div className="view-all d-flex align-items-center justify-content-end">
                      <span
                        onClick={viewAllOurServices}
                        style={{ cursor: "pointer" }}
                      >
                        {" "}
                        {selectedLanguage.id === 1
                          ? "View All"
                          : "Afficher tout"}
                        <i className="bi bi-arrow-up-right-circle ms-1"></i>
                      </span>
                    </div>
                  </a>
                </div>
              </section>

              <section className="service-section text-center mb-5 pb-5">
                <div className="row g-4">
                  {Array.isArray(listofitems) && listofitems.length > 0
                    ? listofitems.map((item, map) => (
                        <div className="col-lg-4 col-md-6">
                          <a className="nav-link">
                            <div className="service-card">
                              <img
                                src={item.image}
                                className="img-fluid service-img"
                                alt="Visa Consultation"
                              />
                              <div
                                className="service-content"
                                style={{ backgroundColor: "#f5e9e9" }}
                              >
                                <div className="d-flex justify-content-between align-items-start">
                                  <h5 className="fw-bold mb-2">
                                    {item.heading}
                                  </h5>
                                  <span
                                    className="faq-two-arrow"
                                    onClick={() => arrowClickExpress(item)}
                                  >
                                    <img src={Arrow1} alt="arrow" />
                                  </span>
                                </div>
                                <p
                                  className="faq-answer clamp-3"
                                  dangerouslySetInnerHTML={{
                                    __html: item.description,
                                  }}
                                ></p>
                              </div>
                            </div>
                          </a>
                        </div>
                      ))
                    : null}
                </div>
              </section>
            </section>
          </div>

          <CheckEligibility showHeader={false} />

          {/* Testimonial Section */}
          {testiMonialSection.length > 0 && (
            <div className="container">
              <section className="">
                <div className="container px-3">
                  <div className="text-left mb-4">
                    <p className="text-danger fw-bold">
                      {testiMonials ? testiMonials.heading : ""}
                    </p>
                    <h2 className="section-title">
                      {testiMonials ? testiMonials.title : ""}
                    </h2>
                    <p
                      className="section-subtitle"
                      dangerouslySetInnerHTML={{
                        __html: testiMonials ? testiMonials.description : "",
                      }}
                    ></p>
                  </div>

                  {/* Top row */}

                  <div className="row g-3 mb-4 position-relative">
                    {videotestimonials.length > visibleCount ? (
                      <button
                        type="button "
                        className="prevbuttonexpressentry rounded"
                        style={
                          startindex === 0
                            ? { display: "none" }
                            : { display: "block" }
                        }
                        onClick={handlePrev}
                        disabled={startindex === 0}
                      >
                        <i
                          className="bi bi-chevron-left bi-hover-bold fs-5 text-black"
                          style={
                            startindex === 0
                              ? { display: "none" }
                              : { display: "block" }
                          }
                        ></i>
                      </button>
                    ) : null}
                    {Array.isArray(videotestimonials) &&
                    videotestimonials.length > 0
                      ? videotestimonials
                          .slice(startindex, startindex + visibleCount)
                          .map((item, index) => {
                            return (
                              <div key={index} className="col-sm-12  col-lg-4">
                                <div className="card-testimonial h-100 rounded-4">
                                  <div className="card-header-img ratio ratio-16x9 mb-3">
                                    <video
                                      src={item.videos?.trim()}
                                      className="w-100 h-100"
                                      controls
                                    ></video>
                                  </div>
                                  <div className="card-body-main">
                                    <div className="person-meta-row">
                                      <div>
                                        <div className="person-name">
                                          {item.name}
                                        </div>
                                        <div className="person-role">
                                          {item.professional}
                                        </div>
                                      </div>
                                      <span className="quote-icon">”</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                      : null}

                    {videotestimonials.length > visibleCount ? (
                      <button
                        type="button"
                        className="nextbuttonexpressentry rounded"
                        onClick={handleNext}
                        disabled={
                          startindex + visibleCount >= videotestimonials.length
                        }
                      >
                        <i className="bi bi-chevron-right bi-hover-bold fs-5 text-dark"></i>
                      </button>
                    ) : null}
                  </div>

                  {/* Bottom row */}
                  <div className="row g-3 position-relative">
                    {videoreviews?.length > visibleCount1 ? (
                      <button
                        type="button"
                        className="prevbuttonexpressentry rounded"
                        style={
                          startindex1 === 0
                            ? { display: "none" }
                            : { display: "block" }
                        }
                        onClick={handlePrev1}
                        disabled={startindex1 === 0}
                      >
                        <i
                          className="bi bi-chevron-left bi-hover-bold text-dark fs-5"
                          style={
                            startindex1 === 0
                              ? { display: "none" }
                              : { display: "block" }
                          }
                        ></i>
                      </button>
                    ) : null}
                    {Array.isArray(videoreviews) && videoreviews.length > 0
                      ? videoreviews
                          .slice(startindex1, startindex1 + visibleCount1)
                          .map((item, index) => (
                            <div
                              className="col-sm-12 col-lg-4"
                              key={item.id || index}
                            >
                              <div className="card-testimonial simple h-100 rounded-4">
                                <div className="card-top d-flex align-items-center justify-content-between gap-2">
                                  <div className="d-flex align-items-center gap-2">
                                    <img
                                      src={item.imageupload || image16}
                                      className="rounded-circle"
                                      width="50"
                                      height="50"
                                      alt="profile"
                                    />
                                    <div>
                                      <div className="bottom-name">
                                        {item.name}
                                      </div>
                                      <div className="bottom-role">
                                        {item.professional}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="rating-wrap">
                                    {renders(item.rating)}
                                  </div>
                                </div>

                                <p
                                  className="bottom-text mb-0 mt-4"
                                  dangerouslySetInnerHTML={{
                                    __html: item.description,
                                  }}
                                ></p>
                              </div>
                            </div>
                          ))
                      : null}
                    {videoreviews.length > visibleCount1 ? (
                      <button
                        type="button"
                        className="nextbuttonexpressentry rounded"
                        onClick={handleNext1}
                        disabled={
                          startindex1 + visibleCount1 >= videoreviews.length
                        }
                      >
                        <i
                          className="bi bi-chevron-right bi-hover-bold fs-5"
                          style={{ fontSize: "15px", color: "black" }}
                        ></i>
                      </button>
                    ) : null}
                  </div>
                </div>
              </section>
            </div>
          )}

          {/* FAQ Section */}
          {faqs?.length > 0 && (
            <div className="container my-5 py-5 px-3">
              <section className="service-header-section text-start mb-4">
                <div className="container-fluid px-2 row d-flex justify-content-between align-items-center">
                  <div className="col-md-8 col-fluid">
                    <h6 className="service-heading text-danger fw-bold">FAQ</h6>
                    <h2 className="faq-sub-heading fw-bold">
                      {selectedLanguage.id === 1
                        ? "Frequently Asked Questions"
                        : "Questions fréquentes"}
                    </h2>
                  </div>
                  <a className="service-view-all text-decoration-none col-md-4 col-lg-3 text-danger fw-bold col-fluid">
                    <div className="view-all d-flex align-items-center justify-content-end">
                      <span onClick={viewAllFaq} style={{ cursor: "pointer" }}>
                        {selectedLanguage.id === 1
                          ? "View All"
                          : "Afficher tout"}
                        <i className="bi bi-arrow-up-right-circle ms-1"></i>
                      </span>
                    </div>
                  </a>
                </div>
              </section>

              <section className="faq-section">
                <div className="row g-4">
                  {Array.isArray(faqs) && faqs.length > 0
                    ? faqs.map((item, index) => (
                        <div className="col-lg-4 col-md-6 " key={index}>
                          <div className="faq-two rounded-4 h-100">
                            <div className="faq-content rounded-4">
                              <img
                                src={FAQ}
                                alt={`FAQ ${index + 1}`}
                                className="faq-img rounded-4 mb-3"
                              />
                              <div className="d-flex justify-content-between align-items-center">
                                <h6 className="faq-question">
                                  {item.question}
                                </h6>
                                <span
                                  className="faq-two-arrow"
                                  onClick={() => faqHandleClick(item, index)}
                                >
                                  <img src={Arrow1} alt="arrow" />
                                </span>
                              </div>
                              <p
                                className="faq-answer"
                                dangerouslySetInnerHTML={{
                                  __html: item.answers,
                                }}
                              ></p>
                            </div>
                          </div>
                        </div>
                      ))
                    : null}
                </div>
              </section>
            </div>
          )}

          {newsList?.length > 0 && (
            <div className="container px-3 my-md-5 py-md-5">
              <section className="service-header-section text-start mb-5">
                <div className="container-fluid px-2 row d-flex justify-content-between align-items-center">
                  <div className="col-md-8 col-fluid">
                    <h6 className="service-subtitle text-danger fw-bold">
                      {selectedLanguage.id === 1 ? "NEWS" : "NOUVELLES"}
                    </h6>
                    <h2 className="section-title mb-0">
                      {selectedLanguage.id === 1 ? "Latest" : "Dernières"}{" "}
                      <span className="highlight fw-bold">
                        {" "}
                        {selectedLanguage.id === 1 ? "NEWS" : "NOUVELLES"}
                      </span>
                    </h2>
                  </div>
                  <a className="service-view-all text-decoration-none col-md-3 text-danger fw-bold col-fluid">
                    <div className="view-all d-flex align-items-center justify-content-end ">
                      <span style={{ cursor: "pointer" }} onClick={viewAllNews}>
                        {" "}
                        {selectedLanguage.id === 1
                          ? "View All"
                          : "Afficher tout"}{" "}
                        <i className="bi bi-arrow-up-right-circle ms-1"></i>
                      </span>
                    </div>
                  </a>
                </div>
              </section>

              <div className="row more-news-row g-4 mb-5">
                {Array.isArray(newsList) && newsList.length > 0
                  ? newsList.map((item, index) => (
                      <div className="col-12 col-lg-4 col-md-6 news-card" key={index}>
                        <div className="category-wrapper d-flex  gap-3">
                          {item.icon_image ? (
                            <img
                              src={item.icon_image}
                              alt="icon"
                              className="category-icon"
                            />
                          ) : (
                            <img src="" />
                          )}
                          <div>
                            <h3 className="categoryname">
                              <span className="truncate">
                                {item.category_name}
                              </span>
                            </h3>
                            <span className="tooltip-text">
                              {item.category_name}
                            </span>
                          </div>
                        </div>

                        <h3 className="mt-4 headlines">{item.heading}</h3>
                        <div className=" d-flex align-items-center gap-2 news-date mt-2 mb-3">
                          <img
                            src={CalendarIcon}
                            className="calendericon"
                            alt="Date"
                          />
                          {item.date || "2025-01-01"}
                        </div>
                        <div className="layerone">
                          <p
                            className="layers  truncated-text"
                            dangerouslySetInnerHTML={{
                              __html: item.news_description,
                            }}
                          ></p>

                          <button
                            className="btn btn-link p-0 mt-2 read-more"
                            onClick={() => handleReadMore(item)}
                          >
                            {selectedLanguage.id === 1
                              ? "Read More"
                              : "Lire la suite"}
                          </button>
                        </div>
                      </div>
                    ))
                  : null}
              </div>
            </div>
          )}
          {list?.length > 0 && (
            <div className="container px-3 my-md-5 py-md-5">
              <section className="service-header-section text-start mb-5">
                <div className="container-fluid px-2 row d-flex justify-content-between align-items-center">
                  <div className="col-md-8 col-fluid">
                    <h6 className="service-subtitle text-danger fw-bold">
                      {selectedLanguage.id === 1 ? "BLOGS" : "BLOGUES"}{" "}
                    </h6>
                    <h2 className="section-title mb-0 fw-bold">
                      {selectedLanguage.id === 1
                        ? "Immigration"
                        : "Immigration"}{" "}
                      <span className="highlight">
                        {selectedLanguage.id === 1 ? "BLOGS" : "BLOGUES"}{" "}
                      </span>
                    </h2>
                  </div>
                  <a className="service-view-all text-decoration-none col-md-3 text-danger fw-bold col-fluid">
                    <div className="view-all d-flex align-items-center justify-content-end">
                      <span onClick={viewallblog} style={{ cursor: "pointer" }}>
                        {selectedLanguage.id === 1
                          ? "View All"
                          : "Afficher tout"}{" "}
                        <i className="bi bi-arrow-up-right-circle ms-1"></i>
                      </span>
                    </div>
                  </a>
                </div>
              </section>

              <div className="row g-4">
                {Array.isArray(list) && list.length > 0
                  ? list.map((item, index) => (
                      <div
                        className={`col-12 col-md-6 ${index === 0 ? "col-lg-4" : "col-lg-4"} mb-4`}
                      >
                        <div className="card blog-card">
                          <img src={item.blog_image} alt="Blog 1" />
                          <div className="blog-body">
                            <div className="blog-title">{item.heading}</div>
                            <p
                              className="blog-text"
                              style={{
                                display: "-webkit-box",
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: cleanHTML(item.description),
                              }}
                            ></p>
                            <p
                              className="blog-read-link fw-bold cursorpointer"
                              onClick={readBlogpage}
                            >
                              {selectedLanguage.id === 1
                                ? "Read Blog"
                                : "Lire le blogue"}
                              <i className="bi bi-arrow-up-right"></i>
                            </p>
                          </div>
                        </div>
                      </div>
                    ))
                  : null}
              </div>
            </div>
          )}

          {/* Contact Section */}
          <section className="contact-section my-5 py-5">
            <div className="container px-3">
              <div className="row align-items-center">
                <div className="col-lg-6 mb-4 contact-info">
                  <h6 className="socialsupportp">
                    {contactus ? contactus.title : ""}
                  </h6>
                  <h1 className="">
                    {contactus ? contactus.heading : ""}
                  </h1>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: contactus ? contactus.description : "",
                    }}
                  ></p>
                  <p>
                    <strong>
                      Address:
                      <br />
                    </strong>{" "}
                    {contactus ? contactus.address : ""}
                  </p>
                  <p>
                    <strong>
                      Phone:
                      <br />
                    </strong>{" "}
                    {contactus ? contactus.phone_number : ""}
                  </p>
                  <p>
                    <strong>
                      Email:
                      <br />
                    </strong>
                    {contactus ? contactus.email : ""}
                  </p>
                </div>

                <div className="col-lg-6">
                  <form className="contact-form">
                    
                    <div className="row g-3">
                      <h6 className="socialsupportp">
                        {contactus ? contactus.title : ""}
                      </h6>

                      <div className="col-md-6">
                        <input
                          type="text"
                          class="form-control"
                          placeholder={
                            selectedLanguage.id === 1
                              ? "Enter Your First Name"
                              : "Entrez votre prénom"
                          }
                          value={firstname}
                          onChange={(e) => setFirstName(e.target.value)}
                        />
                        <p className="text-danger mt-1">{firstnameerr}</p>
                      </div>

                      <div class="col-md-6">
                        <input
                          type="text"
                          class="form-control"
                          placeholder={
                            selectedLanguage.id === 1
                              ? "Enter Your Last Name"
                              : "Entrez votre nom de famille"
                          }
                          value={lastname}
                          onChange={(e) => setLastName(e.target.value)}
                        />
                        <p className="text-danger mt-1">{lastnameerr}</p>
                      </div>

                      <div class="col-md-6">
                        <input
                          type="email"
                          class="form-control"
                          placeholder={
                            selectedLanguage.id === 1
                              ? "Enter  Your Email"
                              : "Entrez votre email"
                          }
                          value={Email}
                          onChange={handleEmail}
                        />
                        <p className="text-danger mt-1">{emailerr}</p>
                      </div>

                      <div class="col-md-6">
                        <select
                          class="form-select p-2"
                          value={contactusvalues}
                          onChange={(e) => dropdownclick(e)}
                        >
                          <option vaue="">
                            {selectedLanguage.id === 1
                              ? "Select"
                              : "Sélectionner"}
                          </option>
                          {dropdown.length > 0 &&
                            dropdown.map((item, index) => (
                              <>
                                <option key={index} value={item.contactform_id}>
                                  {item.label}
                                </option>
                              </>
                            ))}
                        </select>
                        <p className="text-danger mt-1">{selectvalueerr}</p>
                      </div>
                      <div class="col-12">
                        <textarea
                          class="form-control"
                          rows="4"
                          placeholder={
                            selectedLanguage.id === 1
                              ? "Enter your message here..."
                              : "Entrez votre message ici..."
                          }
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                        >
                          {" "}
                        </textarea>

                        <p className="text-danger mt-1">{messageerr}</p>
                      </div>
                      {contactussuccess && (
                        <div class=" d-flex align-items-center flex-nowrap  mt-2 shadow p-3 mb-5 bg-white rounded">
                          <div className="startgreencolour bg-success"></div>
                          <div className="me-2">
                            <i class="bi bi-check-circle-fill text-success  contactussuccesfontsize"></i>
                          </div>
                          <div>
                            <p className="text-success text-start ">
                              {selectedLanguage.id === 1
                                ? "Form Added Successfully"
                                : "Ajout du formulaire réussi"}
                            </p>
                          </div>
                        </div>
                      )}
                      <div class="col-12 text-end">
                        <button
                          type="submit"
                          class="btn btn-danger px-4"
                          onClick={Submit}
                        >
                          {selectedLanguage.id === 1
                            ? "Submit"
                            : "Soumettre"}{" "}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default Home;
